import { render, staticRenderFns } from "./ReporterSupervisarOnly.vue?vue&type=template&id=6641eed6&scoped=true"
import script from "./ReporterSupervisarOnly.vue?vue&type=script&lang=js"
export * from "./ReporterSupervisarOnly.vue?vue&type=script&lang=js"
import style0 from "./ReporterSupervisarOnly.vue?vue&type=style&index=0&id=6641eed6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6641eed6",
  null
  
)

export default component.exports